export interface LessonPlanRecord {
  id: string;
  planType: 'individual' | 'group';
  studentNames: string[];
  theme: string;
  dateStart: string;
  dateEnd: string;
  status: 'draft' | 'submitted' | 'in_progress' | 'completed';
  createdAt: string;
  updatedAt: string;
  isTemplate: boolean;
  templateName: string;
  skillCount: number;
  stepCount: number;
  metricCount: number;
}

export const teacherLessonPlans: LessonPlanRecord[] = [
  {
    id: 'lp-001',
    planType: 'individual',
    studentNames: ['Zara Rodriguez'],
    theme: 'Community Helpers',
    dateStart: '2026-08-03',
    dateEnd: '2026-08-07',
    status: 'submitted',
    createdAt: '2026-07-28T09:15:00Z',
    updatedAt: '2026-07-29T14:22:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 4,
    stepCount: 5,
    metricCount: 3,
  },
  {
    id: 'lp-002',
    planType: 'group',
    studentNames: ['Ishaan Gupta', 'Fatima Begum', 'Vishal Thakur'],
    theme: 'Fall Season Explorers',
    dateStart: '2026-08-10',
    dateEnd: '2026-08-14',
    status: 'draft',
    createdAt: '2026-07-29T11:30:00Z',
    updatedAt: '2026-07-30T08:45:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 3,
    stepCount: 2,
    metricCount: 1,
  },
  {
    id: 'lp-003',
    planType: 'individual',
    studentNames: ['Mei Ling Tan'],
    theme: 'Sensory Regulation Routine',
    dateStart: '2026-07-15',
    dateEnd: '2026-07-18',
    status: 'completed',
    createdAt: '2026-07-10T08:00:00Z',
    updatedAt: '2026-07-19T16:10:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 5,
    stepCount: 6,
    metricCount: 4,
  },
  {
    id: 'lp-004',
    planType: 'individual',
    studentNames: ['Kavya Iyer'],
    theme: 'Fine Motor Bootcamp',
    dateStart: '2026-07-22',
    dateEnd: '2026-07-25',
    status: 'completed',
    createdAt: '2026-07-18T10:00:00Z',
    updatedAt: '2026-07-26T12:30:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 2,
    stepCount: 4,
    metricCount: 2,
  },
  {
    id: 'lp-005',
    planType: 'group',
    studentNames: ['Nandini Pillai', 'Roshan Bhandari'],
    theme: 'Social Stories — Sharing & Turn-Taking',
    dateStart: '2026-08-17',
    dateEnd: '2026-08-21',
    status: 'in_progress',
    createdAt: '2026-07-25T13:45:00Z',
    updatedAt: '2026-07-30T09:10:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 4,
    stepCount: 5,
    metricCount: 3,
  },
  {
    id: 'lp-006',
    planType: 'individual',
    studentNames: ['Zara Rodriguez'],
    theme: 'Daily Living — Morning Routine',
    dateStart: '2026-07-01',
    dateEnd: '2026-07-04',
    status: 'completed',
    createdAt: '2026-06-28T07:00:00Z',
    updatedAt: '2026-07-05T15:00:00Z',
    isTemplate: true,
    templateName: 'Morning Routine Plan',
    skillCount: 3,
    stepCount: 5,
    metricCount: 3,
  },
  {
    id: 'lp-007',
    planType: 'group',
    studentNames: ['Ishaan Gupta', 'Fatima Begum', 'Vishal Thakur', 'Mei Ling Tan'],
    theme: 'Gross Motor — Balance & Coordination',
    dateStart: '2026-08-01',
    dateEnd: '2026-08-02',
    status: 'submitted',
    createdAt: '2026-07-26T14:00:00Z',
    updatedAt: '2026-07-30T10:00:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 3,
    stepCount: 4,
    metricCount: 2,
  },
  {
    id: 'lp-008',
    planType: 'individual',
    studentNames: ['Nandini Pillai'],
    theme: 'Expressive Language Through Play',
    dateStart: '2026-08-24',
    dateEnd: '2026-08-28',
    status: 'draft',
    createdAt: '2026-07-30T08:20:00Z',
    updatedAt: '2026-07-30T08:20:00Z',
    isTemplate: false,
    templateName: '',
    skillCount: 4,
    stepCount: 1,
    metricCount: 0,
  },
  {
    id: 'lp-tpl-001',
    planType: 'individual',
    studentNames: [],
    theme: 'Daily Living — Hand Washing Routine',
    dateStart: '',
    dateEnd: '',
    status: 'draft',
    createdAt: '2026-07-05T09:00:00Z',
    updatedAt: '2026-07-05T09:00:00Z',
    isTemplate: true,
    templateName: 'Hand Washing Routine',
    skillCount: 2,
    stepCount: 4,
    metricCount: 2,
  },
  {
    id: 'lp-tpl-002',
    planType: 'group',
    studentNames: [],
    theme: 'Circle Time — Morning Greeting',
    dateStart: '',
    dateEnd: '',
    status: 'draft',
    createdAt: '2026-07-12T10:00:00Z',
    updatedAt: '2026-07-12T10:00:00Z',
    isTemplate: true,
    templateName: 'Circle Time Morning',
    skillCount: 3,
    stepCount: 5,
    metricCount: 2,
  },
];